export default __webpack_public_path__ + "static/media/arrow_down.b4559859.svg";